import { getLocale } from '@utils';
import i18n from 'i18next';
import translationEN from './locales/en/translation.json';
import translationNL from './locales/nl/translation.json';

const { lng } = getLocale();

const i18nInstance = i18n.createInstance({
  debug: process.env.NODE_ENV !== 'production',
  resources: {
    en: {
      translation: translationEN
    },
    nl: {
      translation: translationNL
    }
  },
  lng,
  ns: [],
  appendNamespaceToMissingKey: true,
  appendNamespaceToCIMode: true,
  returnNull: false
});

i18nInstance.init();

export default i18nInstance;
